import { render, staticRenderFns } from "./save-documents-input.vue?vue&type=template&id=4a9bb3c8&scoped=true&"
import script from "./save-documents-input.vue?vue&type=script&lang=js&"
export * from "./save-documents-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9bb3c8",
  null
  
)

export default component.exports